// Resolves which nav link owns the current pathname.
//
// The old per-link check lived in `SidebarLink` and lit any link whose `to`
// was a prefix of the pathname. That highlighted two links at once wherever a
// section index and its children are both in the nav (e.g. `/racing` stayed
// lit on `/racing/ohr`). Resolving centrally lets the longest match win, so
// exactly one link is ever active.

// A link owns a path on an exact hit, or on a segment-boundary prefix. The
// trailing slash matters: without it `/table/dam` would claim `/table/damsire`.
export const matchesPath = (pathname, to) =>
  pathname === to || pathname.startsWith(to + '/');

// Every path a link answers for: its own `to`, plus any `matchPaths` it
// declares for routes it can't name directly (see `/meetings/latest`).
const candidatesFor = (link) => [link.to, ...(link.matchPaths || [])];

// Returns { to, sectionKey } for the owning link, or null when the route has
// no nav entry (e.g. /dashboard, /horse-chart).
export const resolveActiveLink = (pathname, sections) => {
  let best = null;
  let bestLength = -1;

  for (const section of sections) {
    for (const link of section.links) {
      for (const candidate of candidatesFor(link)) {
        // Longest match wins; `/racing/ohr` (11) beats `/racing` (7).
        if (matchesPath(pathname, candidate) && candidate.length > bestLength) {
          bestLength = candidate.length;
          best = { to: link.to, sectionKey: section.key };
        }
      }
    }
  }

  return best;
};
